import { ADD_TO_ALL_CONTROLLER_ACCOUNTS, BRAND_CATEGORY, SELF_ACCOUNTS } from '../../fields'
import { MEDIA_SUB_CATEGORIES } from '../../ControllerInviteCreate/ControllerInviteCreateForm/fields'

export const getInitialValues = ({ controllerMember = {}, controllerSelfAccountsList, mediaSubCategories }) => {
  const formattedSelfAccounts = controllerMember[SELF_ACCOUNTS]?.map(accountId => {
    const account = controllerSelfAccountsList.find(account => account.id === accountId)
    return account ? { label: account.name, value: account.id } : null
  })

  const mappedMediaSubCategories = controllerMember[MEDIA_SUB_CATEGORIES]?.map(mediaSubCategory => {
    const foundMediaSubCategory = mediaSubCategories.find(category => category.id === mediaSubCategory)
    return {
      ...foundMediaSubCategory,
      value: mediaSubCategory,
      label: foundMediaSubCategory?.name
    }
  })

  return {
    [BRAND_CATEGORY]: controllerMember[BRAND_CATEGORY] || '',
    [MEDIA_SUB_CATEGORIES]: mappedMediaSubCategories || [],

    [SELF_ACCOUNTS]: formattedSelfAccounts,
    [ADD_TO_ALL_CONTROLLER_ACCOUNTS]: controllerMember[ADD_TO_ALL_CONTROLLER_ACCOUNTS] || false
  }
}
